//@flow
import { commitMutation } from 'react-relay';
import type { PayloadError, GraphQLTaggedNode } from 'react-relay';

const onCompleted = (resolve: Object => void) => (response, errors: ?Array<PayloadError>) => {
    if (errors && errors.length) {
        resolve({ hasError: true, errors });
    }
    resolve(Object.assign({}, response, { hasError: false }));
};

const onError = (resolve: Object => void) => (error: Error) => {
    resolve({ hasError: true, errors: [error] });
};

export type OutputType = { hasError: boolean, errors?: Array<Error> } & Object;

export function generateMutation<T>(mutation: GraphQLTaggedNode) {
    return (environment: Object, variables: T): Promise<OutputType> => {
        return new Promise(resolve => {
            try {
                commitMutation(environment, {
                    mutation,
                    variables: { input: variables },
                    onCompleted: onCompleted(resolve),
                    onError: onError(resolve),
                });
            } catch (error) {
                resolve({
                    hasError: true,
                    errors: [error],
                });
            }
        });
    };
}
